export default __webpack_public_path__ + "static/FranklinGothic-Book-8fd15816d440360c621e37bfbf5a1762.woff";